module.exports = __webpack_public_path__ + "static/poligono5_02-8dbe183368edd33ed11009670aa15342.jpg";